import { Box } from '@mui/material';
import logo from 'assets/icons/logo.png';

export default function Logo() {
  return (
    <Box
      component="img"
      src={logo}
      alt="Axis logo"
      sx={{
        height: 50,
        width: 'auto',
        display: 'block',
      }}
    />
  );
}
